<template>
  <div class="swiperComponent mask">
    <div class="desktop">
      <swiper
        :options="swiperOptionTop"
        class="gallery-top"
        ref="swiperTop"
        v-if="pcBanner.length > 0"
      >
        <!-- slides -->
        <!-- 20240926 a取消target:_blank -->
        <swiper-slide class="bigImg" v-for="item in pcBanner" :key="item.href">
          <a
            :href="item.href"
            :data-pagename="item.data_pagename"
            v-if="item.file_type == 'img' && item.href !== null"
            class="banner-theme"
          >
            <img
              :src="item.img"
              alt=""
              :data-pagename="item.data_pagename"
              :class="['banner-theme img-fluid hasUrl ' + item.class]"
            />
          </a>
          <img
            :src="item.img"
            alt=""
            :data-pagename="item.data_pagename"
            :class="['banner-theme img-fluid ' + item.class]"
            v-if="item.file_type == 'img' && item.href == null"
          />
        <!-- 20240926 a取消target:_blank -->
          <a
            :href="item.href"
            :data-pagename="item.data_pagename"
            v-if="item.file_type == 'video' && item.href !== null"
            class="banner-theme"
          >
            <video
              :src="item.img"
              :data-pagename="item.data_pagename"
              ref="videoRef"
              class="video-container banner-theme"
              width="100%"
              controls
            ></video>
          </a>
          <video
            :src="item.img"
            :data-pagename="item.data_pagename"
            ref="videoRef"
            class="video-container banner-theme"
            width="100%"
            controls
            v-if="item.file_type == 'video' && item.href == null"
          ></video>
        </swiper-slide>
        <!-- <swiper-slide class="bigImg" ><img src="../assets/img/home/banner.jpg" alt="" class="img-fluid"></swiper-slide>
        <swiper-slide class="bigImg" ><img src="../assets/img/home/banner02.jpg" alt="" class="img-fluid"></swiper-slide>
        <swiper-slide class="bigImg" ><img src="../assets/img/home/banner03.jpg" alt="" class="img-fluid"></swiper-slide> -->
        <!-- Optional controls -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="mobile">
      <swiper
        :options="swiperOptionTop"
        class="gallery-top"
        ref="swiperTop"
        v-if="mobileBanner.length > 0"
      >
        <!-- slides -->
        <!-- 20240926 a取消target:_blank -->
        <swiper-slide
          class="bigImg"
          v-for="item in mobileBanner"
          :key="item.href"
        >
          <a
            :href="item.href"
            :data-pagename="item.data_pagename"
            v-if="item.file_type == 'img' && item.href !== null"
            class="banner-theme"
          >
            <img
              :src="item.img"
              alt=""
              :data-pagename="item.data_pagename"
              :class="['banner-theme img-fluid hasUrl ' + item.class]"
            />
          </a>
          <img
            :src="item.img"
            alt=""
            :data-pagename="item.data_pagename"
            :class="['banner-theme img-fluid ' + item.class]"
            v-if="item.file_type == 'img' && item.href == null"
          />
          <!-- 20240926 a取消target:_blank -->
          <a
            :href="item.href"
            :data-pagename="item.data_pagename"
            v-if="item.file_type == 'video' && item.href !== null"
            class="banner-theme"
          >
            <video
              :src="item.img"
              :data-pagename="item.data_pagename"
              ref="videoRef"
              class="video-container banner-theme"
              width="100%"
              muted
              controls
            ></video>
          </a>
          <video
            :src="item.img"
            :data-pagename="item.data_pagename"
            ref="videoRef"
            class="video-container banner-theme"
            width="100%"
            muted
            controls
            v-if="item.file_type == 'video' && item.href == null"
          ></video>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import axios from 'axios'
import { mapActions, mapState } from 'vuex'

export default {
  props: ['viewportWidth'],
  name: 'carrousel',
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    openUrl (url) {
      window.open(url)
    },
    ...mapActions('homeSwiperModules', ['getBanner'])
  },
  computed: {
    ...mapState('homeSwiperModules', ['pcBanner', 'mobileBanner'])
  },
  data () {
    return {
      // pcBanner: [],
      // mobildBanner: [],
      time: null,
      swiperOptionTop: {
        notNextTick: true,
        loop: true,
        initialSlide: 0,
        clickable: true,
        // spaceBetween: 10,
        // slidesPerView: 1,
        // loopedSlides: 1, // looped slides should be the same
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets'
        },
        updateOnWindowResize: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        }
      }
    }
  },
  async created () {
    await this.getBanner()
  }
}
</script>

<style lang="scss" scoped>
img {
  aspect-ratio:attr(width)/attr(height);
  width: 100%;
  }
.mobile {
  display: none;
  margin: auto;
}
.desktop {
  display: initial;
  margin: auto;
}
@media (max-width: 640px) {
  .mobile {
    display: initial;
    margin: auto;
  }
  .desktop {
    display: none;
  }
}
.hasUrl {
  cursor: pointer;
}

.zoomIn {
  -webkit-animation: scale 18s linear infinite;
  animation: scale 18s linear infinite;
}
// TODO 20221201 修改zoomin速度

@-webkit-keyframes scale {
  from {
    -webkit-transform: scale(1, 1);
  }

  to {
    -webkit-transform: scale(1.2, 1.2);
  }
}

@keyframes zoom {
  from {
    transform: scale(1, 1);
  }

  to {
    transform: scale(1.2, 1.2);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/homeSwiper.vue